import { Injectable } from "@angular/core";

import { ApiService } from "./api.service";
import { ApiResponse } from "../shared/interfaces/api-response";
import { WalkHistoryDetails } from "../shared/interfaces/walk-history-details";
import { WalkMemberDetails } from "../shared/interfaces/walk-member-details";

@Injectable({
  providedIn: "root",
})
export class WalksService {
  walkRecord: WalkHistoryDetails = { MemberId: "" };
  constructor(private apiService: ApiService) {}

  getWalkInfo(member: WalkMemberDetails) {
    this.walkRecord.Comments = member.Comments;
    this.walkRecord.DurationInMinutes = member.DurationInMinutes;
    this.walkRecord.FirstName = member.FirstName;
    this.walkRecord.Hours = member.Hours;
    this.walkRecord.HouseId = member.HouseId;
    this.walkRecord.HouseName = member.HouseName;
    this.walkRecord.ID = member.ID;
    this.walkRecord.ImageExists = member.ImageExists;
    this.walkRecord.KickedOff = member.KickedOff;
    this.walkRecord.KickedOffReason = member.KickedOffReason;
    this.walkRecord.LastName = member.LastName;
    this.walkRecord.MemberId = member.MemberId;
    this.walkRecord.MemberName = member.MemberName;
    this.walkRecord.MiddleName = member.MiddleName;
    this.walkRecord.Minutes = member.Minutes;
    this.walkRecord.SignInHour = member.SignInHour;
    this.walkRecord.SignInLocalTime = member.SignInLocalTime;
    this.walkRecord.SignInMethod = member.SignInMethod;
    this.walkRecord.SignInMinute = member.SignInMinute;
    this.walkRecord.SignInTime = member.SignInTime;
    this.walkRecord.SignOutHour = member.SignOutHour;
    this.walkRecord.SignOutLocalTime = member.SignOutLocalTime;
    this.walkRecord.SignOutMethod = member.SignOutMethod;
    this.walkRecord.SignOutMinute = member.SignOutMinute;
    this.walkRecord.SignOutTime = member.SignOutTime;
    this.walkRecord.StrikeHouseId = member.StrikeHouseId;
    this.walkRecord.StrikeInfoId = member.StrikeInfoId;
    this.walkRecord.StrikeMemberId = member.StrikeMemberId;
    this.walkRecord.StrikePicketlineId = member.StrikePicketlineId;
    this.walkRecord.WalkDate = member.WalkDate;

    return this.walkRecord;
  }

  async updateWalkInfo(walkInfo: WalkMemberDetails) {
    const response: ApiResponse = await this.apiService.post(
      "/api/strikewalk/updateManual",
      walkInfo,
    );
    return response;
  }

  async adjustWalkInfo(walkInfo: WalkMemberDetails) {
    const response: ApiResponse = await this.apiService.post("api/strikewalk/adjust/", walkInfo);
    return response;
  }

  async deleteWalkInfo(member: WalkMemberDetails) {
    const response: ApiResponse = await this.apiService.post("api/strikewalk/delete/" + member.ID, null);
    return response
  }
}
